<script>
import { Line, mixins } from 'vue-chartjs'

const { reactiveProp } = mixins

export default {
  name: 'MetricsChart',
  extends: Line,
  mixins: [reactiveProp],
  props: {
    historicalMetrics: {
      type: Array,
      default: () => []
    },
    chartData: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      chartOptions: {
        responsive: true,
        maintainAspectRatio: false,
        height: 300,
        scales: {
          yAxes: [{
            ticks: {
              beginAtZero: true,
              max: 100,
              callback: function(value) {
                return value + '%'
              }
            },
            scaleLabel: {
              display: true,
              labelString: 'Utilização (%)'
            }
          }],
          xAxes: [{
            scaleLabel: {
              display: true,
              labelString: 'Horário'
            }
          }]
        },
        legend: {
          display: true,
          position: 'top',
          labels: {
            fontColor: '#495057',
            usePointStyle: true,
            padding: 20
          }
        },
        tooltips: {
          mode: 'index',
          intersect: false,
          backgroundColor: 'rgba(0,0,0,0.8)',
          titleFontColor: 'white',
          bodyFontColor: 'white',
          borderColor: 'rgba(255,255,255,0.3)',
          borderWidth: 1,
          callbacks: {
            label: function(tooltipItem, data) {
              return data.datasets[tooltipItem.datasetIndex].label + ': ' + tooltipItem.yLabel + '%'
            }
          }
        },
        elements: {
          point: {
            radius: 4,
            hoverRadius: 6
          }
        }
      }
    }
  },
  computed: {
    processedChartData() {
      if (!this.historicalMetrics || this.historicalMetrics.length === 0) {
        return {
          labels: ['Sem dados'],
          datasets: [
            {
              label: 'CPU (%)',
              data: [0],
              borderColor: '#667eea',
              backgroundColor: 'rgba(102, 126, 234, 0.1)',
              fill: false,
              tension: 0.4
            },
            {
              label: 'RAM (%)',
              data: [0],
              borderColor: '#4facfe',
              backgroundColor: 'rgba(79, 172, 254, 0.1)',
              fill: false,
              tension: 0.4
            },
            {
              label: 'Disco (%)',
              data: [0],
              borderColor: '#fa709a',
              backgroundColor: 'rgba(250, 112, 154, 0.1)',
              fill: false,
              tension: 0.4
            }
          ]
        }
      }
      
      const labels = this.historicalMetrics.map(m => {
        const date = new Date(m.collected_at)
        return date.toLocaleTimeString('pt-BR', { 
          hour: '2-digit', 
          minute: '2-digit' 
        })
      })
      
      return {
        labels: labels,
        datasets: [
          {
            label: 'CPU (%)',
            data: this.historicalMetrics.map(m => parseFloat(m.cpu_usage_percent) || 0),
            borderColor: '#667eea',
            backgroundColor: 'rgba(102, 126, 234, 0.1)',
            fill: false,
            tension: 0.4,
            pointBackgroundColor: '#667eea',
            pointBorderColor: '#ffffff',
            pointBorderWidth: 2
          },
          {
            label: 'RAM (%)',
            data: this.historicalMetrics.map(m => parseFloat(m.ram_used_percent) || 0),
            borderColor: '#4facfe',
            backgroundColor: 'rgba(79, 172, 254, 0.1)',
            fill: false,
            tension: 0.4,
            pointBackgroundColor: '#4facfe',
            pointBorderColor: '#ffffff',
            pointBorderWidth: 2
          },
          {
            label: 'Disco (%)',
            data: this.historicalMetrics.map(m => parseFloat(m.disk_used_percent) || 0),
            borderColor: '#fa709a',
            backgroundColor: 'rgba(250, 112, 154, 0.1)',
            fill: false,
            tension: 0.4,
            pointBackgroundColor: '#fa709a',
            pointBorderColor: '#ffffff',
            pointBorderWidth: 2
          }
        ]
      }
    }
  },
  mounted() {
    this.renderChart(this.processedChartData, this.chartOptions)
  },
  watch: {
    historicalMetrics: {
      handler() {
        this.updateChart()
      },
      deep: true
    }
  },
  methods: {
    updateChart() {
      if (this.$data._chart) {
        this.$data._chart.destroy()
      }
      this.$nextTick(() => {
        this.renderChart(this.processedChartData, this.chartOptions)
      })
    }
  }
}
</script>

<style scoped>
canvas {
  background: white;
  border-radius: 8px;
}
</style> 